module.exports = __webpack_public_path__ + "img/1561708937.1c168496.jpg";